export const getMailMessage = (state) => state.mail
export const getEmailEnum = (state) => state.emailEnum